import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getAggregateTable } from "../../../Requests/deltaHedgeAccounts";
import { IDeltaHedgeAccountAggregateReportSearchParam } from "../../../Interfaces/deltaHedgeAccounts";
import { Additional } from "./Additional/Additional";

interface IProps {
  searchParams: IDeltaHedgeAccountAggregateReportSearchParam;
}

const AggregateTable = ({ searchParams }: IProps) => {
  if (!searchParams.groupId) return <></>;

  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
        />
      )}
      getDataTable={getAggregateTable}
      searchParameters={searchParams}
      refreshTableTime={5000}
    />
  );
};

export default AggregateTable;
